import React from 'react';

import { IForm } from '@entities/AdminConversationCategory/model/types';
import { Newsletter } from '@features/ConversationClientModal/ui/Newsletter';
import { Survey } from '@features/ConversationClientModal/ui/Survey';
import { collapseForm } from '@widgets/ConversationBanner/api/collapseForm';

export const useConversationClientModal = ({
    prevData,
    close,
    onSendSurvey,
}: {
    close: () => void;
    onSendSurvey?: () => void;
    prevData?: IForm;
}) => {
    // @ts-ignore
    const conversationClientData = modalData;
    //
    if (Array.isArray(conversationClientData && !prevData)) {
        return null;
    }

    const closeModal = async () => {
        if (prevData) {
            close();
            return;
        }

        // @ts-ignore
        if (bannerData.id !== modalData.id) {
            await collapseForm(conversationClientData.id);
        }
        // @ts-ignore
        bannerData = modalData;
        // @ts-ignore
        modalData = [];
        close();
    };

    const typeMapping: Record<string, React.ReactNode> = {
        broadcast: <Newsletter prevData={prevData} />,
        survey: <Survey prevData={prevData} onClose={prevData ? closeModal : onSendSurvey} />,
    };

    return { closeModal, conversationClientData, typeMapping };
};
